import { Routes, RouterModule } from '@angular/router';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService, LoginGuard } from 'iui-iconectiv-lib';

import { AccountCompletionComponent } from './account-completion';
import { CanDeactivateGuard } from './shared/can-deactivate-guard.service';
import { RegisterComponent } from './register';
import { Roles } from './shared';
import { SearchComponent } from './search';
import { ServiceAgreementComponent } from './service-agreement';
import { ServiceDeskComponent } from './servicedesk';
import { SummaryComponent } from './summary/summary.component';
import { SupportComponent, LearnMoreComponent, PrivacyComponent } from './support';
import {AdminAccountComponent} from "./admin-account";
import {UsageDetailsComponent} from "./usage-details";
import {UserManagementComponent} from "./user-management";
import {ReportsComponent} from "./reports";
import {ReportsQueueComponent} from "./reports";
import { 
  ReportAccessGuard as ReportAccessGuard 
} from './shared/reportaccessrout.service';

const routes: Routes = [
  { path: 'finder', component: SummaryComponent, canActivate: [LoginGuard] },
  { path: 'summary', component: SummaryComponent, canActivate: [LoginGuard] },
  { path: 'account-completion', component: AccountCompletionComponent, canActivate: [LoginGuard] },
  { path: 'service-agreement', component: ServiceAgreementComponent, canActivate: [LoginGuard] },
  { path: 'servicedesk', component: ServiceDeskComponent, canActivate: [LoginGuard] },
  // { path: '', component: SearchComponent, canActivate: [LoginGuard] },
  { path: 'search', component: SearchComponent, canActivate: [LoginGuard] },
  { path: 'usage/:accountId', component: UsageDetailsComponent, canActivate: [LoginGuard] },
  { path: 'accountmanagement', component: AdminAccountComponent},
  { path: 'usermanagement', component: UserManagementComponent},
  { path: 'usermanagement/:accountId', component: UserManagementComponent},
  { path: 'support', component: SupportComponent, canActivate: [LoginGuard] },
  { path: 'learnmore', component: LearnMoreComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'register', component: RegisterComponent },

  { path: 'reportsqueue', component: ReportsQueueComponent, 
    canActivate: [LoginGuard, ReportAccessGuard],
    data: {
      reportAccess: true,
    } 
  },
  { path: 'reportsqueue/:id', component: ReportsQueueComponent, 
    canActivate: [LoginGuard, ReportAccessGuard],
    data: {
      reportAccess: true,
    } 
  },
  { path: '**', component: SummaryComponent, canActivate: [LoginGuard]}
];

export const appRoutingProviders: any[] = [];

export const routing = RouterModule.forRoot(routes);
